/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { SimpleError } from "src/components/UI/Error/Errors";
import { Loading } from "src/components/UI/Loading/Loading";
import { InlineSpinner } from "src/components/UI/Loading/Spinners/InlineSpinner";
import { LoadingStatus } from "src/lib/types";

export enum LoadingType {
  Fullscreen,
  Inline,
  Hidden,
}
interface Props {
  status: LoadingStatus;
  loadingType: LoadingType;
  message?: string;
  children: React.ReactNode | React.ReactNode[];
}
export function LoadingWrapper({ status, loadingType, message, children }: Props) {
  return (
    <>
      {(() => {
        switch (status) {
          case LoadingStatus.Idle:
            return <div></div>;
          case LoadingStatus.Loading:
            return <Loading type={loadingType} />;
          case LoadingStatus.Succeeded:
            return children;
          case LoadingStatus.LoadingMore:
            return (
              <>
                {children}
                <InlineSpinner />
              </>
            );
          case LoadingStatus.Failed:
            return <SimpleError message={message} />;
        }
      })()}
    </>
  );
}
